import * as Yup from "yup";

export const specialisationSchema = Yup.object().shape({
  name: Yup.string().required("Specialisation name is required"),
  description: Yup.string().nullable(),
  academic_program_id: Yup.string().required("Academic program is required"),
});
